module.exports = __webpack_public_path__ + "static/img/40.4b2d1ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/40.png
// module id = yBCF
// module chunks = 0